const getConfirmedClassicURL = (hostName: string) => {
  if (hostName.includes('use.confirmedapp.com'))
    return 'https://www.confirmedapp.com';

  if (hostName.includes('staging2.confirmedapp.com'))
    return 'https://confirmedapp-staging.azurewebsites.net';
  else return 'http://localhost:3000';
};

export default getConfirmedClassicURL;
